import React, { Suspense } from "react";
import { isUserAuthenticated } from "@/helpers";
import { Navigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";

const PublicRoute = ({ children }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const redirectURL = params.get("redirect_uri");
  const parentCategories = localStorage.getItem("permissions");
  const parseParentCategories = JSON.parse(parentCategories);
  // Permissions are populated asynchronously after login (see Topbar), so an
  // empty/missing list here means "not loaded yet", not "denied" — only treat
  // it as a denial once we actually have a populated list to check against.
  const hasKnownPermissions =
    Array.isArray(parseParentCategories) && parseParentCategories.length > 0;
  const checkPermission = parseParentCategories?.some((someItem) =>
    redirectURL?.includes(someItem)
  );

  const authed = isUserAuthenticated();

  if (redirectURL && authed && hasKnownPermissions && !checkPermission) {
    toast.error("Access denied!");
    return <Navigate to={"/dashboard"} />;
  } else if (redirectURL && authed) {
    return <Navigate to={`${redirectURL}`} />;
  } else if (authed) {
    return <Navigate to={"/dashboard"} />;
  }
  return (
    <div>
      <Suspense>{children}</Suspense>
    </div>
  );
};

export default PublicRoute;
